import React from 'react';
import { AuthProvider } from '@ftdr/use-auth/build';
import { ProfileProvider } from '../ProfileContext';
import { OptimizelyProvider } from '@context/OptimizelyContext';
import { NewOrderProvider } from '@context/NewOrderContext';
import { FEOptimizelyProvider } from '@context/OptimizelyContext/fe-index';

const CombinedProvider = ({ children, serviceConfigs }) => (
  <AuthProvider serviceConfigs={serviceConfigs}>
    <ProfileProvider>
      <OptimizelyProvider>
        <FEOptimizelyProvider>
          <NewOrderProvider>{children}</NewOrderProvider>
        </FEOptimizelyProvider>
      </OptimizelyProvider>
    </ProfileProvider>
  </AuthProvider>
);

export default CombinedProvider;
